import API from "@constants/API";

const BASE_URL = "https://api.dev.daily.co.id/dashboard/code/code";

export const getOjolCodeAPI = async () => {
  const response = await API.HTTP.get(`${BASE_URL}`);

  return response;
};
